import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwModalHandler, DwModalConfig, DwModalResult, DwMessage, DwButtonConfig, DwButtonCommand, DwMessageSeverity, DwRadioItem } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { SchoolIntegrationCompletionRequest } from '../../../integration/models/school-integration-completion-request.model';
import { SchoolIntegrationResponse, SchoolIntegrationResponseType } from '../../../integration/models/school-integration-response.model';
import { IntegrationRepositoryService } from '../../../integration/services/integration-repository.service';
import { EndorsementActionType, SchoolCourseEndorsementActionRequest } from '../../models/school-course-endorsement-action-request.model';
import { SchoolRepositoryService } from '../../services/school-repository.service';
import { map } from 'rxjs/operators';
import { result } from 'underscore';
import { SchoolCourseEndorsementActionResult } from '../../models/school-course-endorsement-action-result.model';
import { StudentCourseEntity } from '../../../../meta-data/app-meta-data.service';

@Component({
  selector: 'app-student-course-endorsement-action-modal',
  templateUrl: './student-course-endorsement-action-modal.component.html',
  styleUrls: ['./student-course-endorsement-action-modal.component.scss']
}) 
export class StudentCourseEndorsementActionModalComponent implements OnInit, DwModalHandler {
  response: SchoolIntegrationResponse;
  request: SchoolCourseEndorsementActionRequest;
 
  constructor(private schoolRepositoryService: SchoolRepositoryService) { }

  modalConfig: DwModalConfig<StudentCourseEntity>;
  closeModal: EventEmitter<DwModalResult<any>>;
  message: DwMessage; 

  processing = false;

  actions: DwRadioItem[] = [
    { display: 'Delete Endorsement and Reset Quiz Finals', value: EndorsementActionType.deleteEndorementAndResetFinals },
    { display: 'Recreate Endorsement', value: EndorsementActionType.recreateEndorsement },
    { display: 'Delete Endorsement (Doesn\'t affect progress)', value: EndorsementActionType.deleteEndorsement },
  ]
 
  ngOnInit(): void {

    this.request = {
      StudentCourseId: this.modalConfig.data.StudentCourseId,
      ActionType: EndorsementActionType.deleteEndorementAndResetFinals,
      UpdateCompletedDateTime: false
    };
  }


  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    const result = new DwModalResult();
    result.cancelled = false;

    switch (buttonConfig.command) {
      case DwButtonCommand.ok:
      case DwButtonCommand.saveAndClose:
      case DwButtonCommand.save:
        return this.executeAction();
      case DwButtonCommand.cancel:
        result.closeModal = true;
        result.cancelled = true;
    }
    return of(result);
  }

  executeAction(): Observable<DwModalResult<any>> {

    this.message = null;
    this.processing = true;
    return this.schoolRepositoryService.studentCourseEndorsementAction(this.request)
      .pipe(map((actionResult) => {
      this.processing = false;
        const result = new DwModalResult<SchoolCourseEndorsementActionResult>();

        if (actionResult.Success) {
          result.closeModal = true;
          result.data = actionResult;

          return result;
        }

        result.closeModal = false;

        this.message = {
          severity: DwMessageSeverity.error,
          messageBody: actionResult.Message
        };

        return result;
      }));

  }
}
